// getServerSideProps doesn't allow undefined values for resolved props
// https://github.com/vercel/next.js/discussions/11209
export const removeUndefinedForNextJsSerializing = <T>(object: T): T =>
  Object.fromEntries(Object.entries(object).filter(([, value]) => value !== undefined)) as T;
